import React from 'react';
import './tos.css'

const TOS = () => {
  return (
    <div>
      <h1>Terms of Service</h1>
    </div>
  );
};

export default TOS;
